import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";

const statusStyle = {
  open: "bg-amber-500/15 text-amber-300 border border-amber-500/40",
  won: "bg-emerald-500/15 text-emerald-300 border border-emerald-500/40",
  lost: "bg-red-500/15 text-red-300 border border-red-500/40",
  void: "bg-zinc-700 text-zinc-300",
};

export default function MyBets({ reloadKey }) {
  const [bets, setBets] = useState([]);
  const [tab, setTab] = useState("open");
  useEffect(() => {
    api.get("/bets/me").then((r) => setBets(r.data.items));
  }, [reloadKey]);
  const rows = bets.filter((b) => (tab === "open" ? b.status === "open" : b.status !== "open"));

  return (
    <div className="bg-zinc-950 border border-amber-500/20 rounded-md overflow-hidden" data-testid="my-bets">
      <div className="flex items-center justify-between bg-zinc-900 px-3 py-2">
        <div className="font-display uppercase tracking-widest text-amber-400 text-sm">My Bets</div>
        <Tabs value={tab} onValueChange={setTab}>
          <TabsList className="bg-black h-8">
            <TabsTrigger value="open" data-testid="mybets-open-tab" className="text-xs data-[state=active]:bg-amber-400 data-[state=active]:text-black">
              Open ({bets.filter((b) => b.status === "open").length})
            </TabsTrigger>
            <TabsTrigger value="settled" data-testid="mybets-settled-tab" className="text-xs data-[state=active]:bg-amber-400 data-[state=active]:text-black">
              Settled
            </TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
      {rows.length === 0 && <div className="p-6 text-sm text-zinc-500" data-testid="mybets-empty">No {tab} bets.</div>}
      {rows.map((b) => (
        <div key={b.id} className="grid grid-cols-12 gap-2 items-center px-3 py-2.5 border-b border-zinc-800 text-sm" data-testid={`bet-row-${b.id}`}>
          <div className="col-span-12 sm:col-span-5 min-w-0">
            <div className="font-semibold truncate">{b.selection}</div>
            <div className="text-[11px] text-zinc-400 truncate">{b.match_name}</div>
          </div>
          <div className="col-span-4 sm:col-span-2">
            <span className="text-xs font-bold uppercase" style={{ color: b.side === "back" ? "#72BBEF" : "#FAA9BA" }}>{b.side}</span>
            <span className="font-mono-stat ml-1">@{b.price.toFixed(2)}</span>
          </div>
          <div className="col-span-4 sm:col-span-2 font-mono-stat text-xs">
            <div>Stake {b.stake.toFixed(2)}</div>
            <div className="text-zinc-500">Risk {b.liability.toFixed(2)}</div>
          </div>
          <div className="col-span-4 sm:col-span-3 text-right">
            <Badge className={statusStyle[b.status]}>{b.status}</Badge>
            <div className="font-mono-stat text-xs mt-1 text-zinc-400">
              {b.status === "open" ? `Win ${b.profit.toFixed(2)}` : `Paid ${b.payout.toFixed(2)}`}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
